import { MNSproCloudApi } from '..';
import {
  CourseLinkCreateRequest,
  CourseLinkResponse,
  CourseLinkUpdateRequest,
} from '../api/v2';

export class GroupLinksService {
  static async getFavorites(
    authToken: string,
    organizationId: string,
    groupId: string,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.CourseLinksApiFactory(config);

    const result = await api
      .getList(organizationId, groupId)
      .then(l => api.getFavorites(organizationId, groupId, l.data?.id ?? ''));

    return result.data;
  }

  static async getAll(
    authToken: string,
    organizationId: string,
    groupId: string,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.CourseLinksApiFactory(config);

    const result = await api
      .getList(organizationId, groupId)
      .then(l => api.getAll(organizationId, groupId, l.data?.id ?? ''));

    return result.data;
  }

  static async creatLink(
    authToken: string,
    organizationId: string,
    groupId: string,
    courseLinkCreateRequest: CourseLinkCreateRequest,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.CourseLinksApiFactory(config);

    const result = await api.getList(organizationId, groupId).then(l =>
      api.create(organizationId, {
        ...courseLinkCreateRequest,
        listId: l.data?.id ?? '',
      }),
    );

    return result.data;
  }

  static async updateLink(
    authToken: string,
    organizationId: string,
    groupId: string,
    courseLinkCreateRequest: CourseLinkUpdateRequest,
  ): Promise<CourseLinkResponse> {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.CourseLinksApiFactory(config);

    const listResponse = await api.getList(organizationId, groupId);
    const list = listResponse.data;

    const udpateResponse = await api.update(organizationId, {
      ...courseLinkCreateRequest,
      listId: list.id ?? '',
    });

    return udpateResponse.data;
  }

  static async deleteLink(
    authToken: string,
    organizationId: string,
    groupId: string,
    linkId: string,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.CourseLinksApiFactory(config);

    const result = await api
      .getList(organizationId, groupId)
      .then(l =>
        api._delete(organizationId, groupId, l.data?.id ?? '', linkId),
      );

    return result.data;
  }
}
